import { Checkbox as CheckboxPrimitive } from 'radix-ui'
import * as React from 'react'

import { cn } from '@/legacy-src/lib/utils'

export const CheckboxCard = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'mt-0 rounded-lg border-none bg-white px-4 py-3 text-sm text-secondary transition-colors disabled:bg-sand-700 disabled:text-white data-[state=checked]:bg-secondary data-[state=checked]:text-white data-[state=checked]:outline-none',
      className,
    )}
    {...props}
  ></CheckboxPrimitive.Root>
))

CheckboxCard.displayName = 'CheckboxCard'
